



























import Vue from "vue";
import { Role } from "../../services/vo";
export default Vue.extend({
  name: "RegisterForm",
  data() {
    return {
      uname: "",
      pw: "",
      role: 2
    };
  },
  computed: {
    roles: function(): Role[] {
      const roles: Role[] = new Array<Role>();

      roles.push(new Role(2, "User"));
      roles.push(new Role(1, "Admin"));

      return roles;
    },
    valid: function(): boolean {
      let valid: boolean = true;

      valid = this.pw.length > 0 && this.uname.length > 0;

      return valid;
    }
  },
  methods: {
    register: function() {
      if (this.valid) {
        this.$emit("register", this.uname, this.pw, this.role);
      }
    }
  }
});
